import { modelosDocumentoService } from '@/features/modelos-documento/api';
import { modelosDecursoPageSize } from '../../utils/modelosDecursoConstants';
export const modelosDecursoService = {
  listar: (page: number) =>
    modelosDocumentoService.list({
      categoria: 'CERTIDAO_DECURSO',
      apenasAtivos: true,
      page,
      pageSize: modelosDecursoPageSize,
    }),
};
